import { paymentService } from 'services'
import { PaymentType, usePaymentStore } from 'state/usePaymentStore'
import useSWR, { SWRConfiguration } from 'swr'
import SWR_KEY from './constant'

export type ChainType = {
	token_id: number,
	network: string,
	network_type: string,
	chain_id: string,
	price: string,
	price_vnd: string,
	fee: string,
	decimals: string
}

export const useGetPaymentList = (configs?: SWRConfiguration) => {
	const paymentList = usePaymentStore((s) => s.paymentList)
	const setPaymentList = usePaymentStore((s) => s.setPaymentList)
	const setSelectedPayment = usePaymentStore((s) => s.setSelectedPayment)

	const fetchData = async () => await paymentService.getList(SWR_KEY.GET_PAYMENT_LIST).then(({ data }) => {
		const { data: list } = data

		setPaymentList((list as PaymentType[]).map(item => ({
			id: item.id,
			name: item.name,
			user_id: item.user_id,
			account_number: item.account_number,
			account_holder: item.account_holder,
			bank_id: item.bank_id,
		})))

		if (list.length) setSelectedPayment({
			id: list[0].id,
			name: list[0].name,
			user_id: list[0].user_id,
			account_number: list[0].account_number,
			account_holder: list[0].account_holder,
			bank_id: list[0].bank_id,
		})

		return list
	})

	return useSWR(!paymentList ? SWR_KEY.GET_PAYMENT_LIST : null, fetchData, {
		fallbackData: paymentList,
		revalidateOnFocus: false,
		...configs
	})
}

export const useGetChainList = (symbol: string, configs?: SWRConfiguration) => {
	return useSWR([SWR_KEY.GET_CHAIN_LIST, symbol], paymentService.getChainList, {
		revalidateOnFocus: false,
		...configs
	})
}

export const useGetWallet = (network: string | undefined, configs?: SWRConfiguration) => {
	return useSWR(network ? [SWR_KEY.GET_WALLET, network] : null, paymentService.getWallet, {
		revalidateOnFocus: false,
		...configs
	})
}

export const useBankList = (configs?: SWRConfiguration) => {
	const fetchData = async (key: string) => await paymentService.getList(key).then(({ data }) => {
		return data.data
	})

	return useSWR(SWR_KEY.GET_BANK_LIST, fetchData, {
		revalidateOnFocus: false,
		...configs
	})
}